import React from "react";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";
import CreateForm from "../components/electronic-prescription/CreateForm";
//import Button from "@material-ui/core/Button";

class ElectronicPrescription extends React.Component {
  initialState = {
    cat_productos: [],
    cat_presentacion_producto: [],
    cat_producto_especie_dosis: [],
    cat_establecimientos: [],
    cat_producto_descarte: [],
    cat_medida_tiempo: Api.loadCatalogue("cat_medida_tiempo"),
    producto: "",
    presentacion: "",
    establecimiento: "",
    fabricante: "",
    cantidad_texto: "",
    cantidad_numero: "",
    paisOrigen: "",
    propietario_nombre: "",
    propietario_direccion: "",
    explotacion_pecuaria_direccion: "",
    explotacion_pecuaria_razon: "",
    cantidad_tratar: "",
    producto_especie_dosis: "",
    frecuencia: "",
    tratamiento: "",
    producto_descarte: "",
    medida_tiempo_frecuencia: "",
    medida_tiempo_tratamiento: "",
    nivelUsuario: localStorage.nivel_actual,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel medico veterinario ipsa redireccionamos a home
    if (!["1", "7"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    // cargar catálogo de productos controlados
    this.getControlledProductsTypeVet();
    // cargar catálogo de establecimientos relacionados al medico tipo farmacia veterinaria
    this.loadVeterinaryPharmacyEstablishments();
  }

  /********* LLAMADAS A LA API ***********/

  getControlledProductsTypeVet = () => {
    Api.loading(true);
    Api.fetch("app/getControlledProductsTypeVet")
      .then((data) => {
        if (data) {
          this.setState({ cat_productos: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  loadVeterinaryPharmacyEstablishments = () => {
    Api.loading(true);
    Api.fetch("app/loadVeterinaryPharmacyEstablishments")
      .then((data) => {
        if (data) {
          this.setState({ cat_establecimientos: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getWithdrawalPeriodProduct = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getWithdrawalPeriodProduct?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_producto_descarte: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getControlledProductPresentation = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductPresentation?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_presentacion_producto: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getProductControlledSpecieDose = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductControlledSpecieDose?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_producto_especie_dosis: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getProductManufacturers = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductManufacturers?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ fabricante: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  /********** FUNCIONES PARA CONTROLAR EVENTOS **********/

  handleProductChange = (obj) => {
    // reiniciamos presentacion en caso de que tenga un valor, y asignamos otros valores correspondientes al objeto de productos
    this.setState({
      producto: obj,
      presentacion: this.initialState.presentacion,
      producto_especie_dosis: this.initialState.producto_especie_dosis,
      paisOrigen: obj.pais,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("producto");
    this.cleanErrorsValidation("fabricante");
    this.cleanErrorsValidation("paisOrigen");

    // buscamos la/las presentaciones del producto
    this.getControlledProductPresentation(obj.id);
    // buscamos el cat dosis producto especies dosis
    this.getProductControlledSpecieDose(obj.id);
    // buscamos el cat de fabricante del producto
    this.getProductManufacturers(obj.id);
    // buscamos el cat de producto descarte
    this.getWithdrawalPeriodProduct(obj.id);
  };

  handlePresentationChange = (obj) => {
    // limpamos errores si es que los hay
    this.cleanErrorsValidation("presentacion");

    // le damos el valor del objeto de presentación seleccionado a presentacion
    this.setState({ presentacion: obj });
  };

  handleDoseSpeciesChange = (obj) => {
    this.cleanErrorsValidation("producto_especie_dosis");
    this.setState({ producto_especie_dosis: obj });
  };

  handleWithdrawalPeriodChange = (obj) => {
    this.setState({ producto_descarte: obj });
  };

  handleFrecuencyMeasureTimeChange = (obj) => {
    this.cleanErrorsValidation("medida_tiempo_frecuencia");
    this.setState({ medida_tiempo_frecuencia: obj });
  };

  handleTreatmentMeasureTimeChange = (obj) => {
    this.cleanErrorsValidation("medida_tiempo_tratamiento");
    this.setState({ medida_tiempo_tratamiento: obj });
  };

  handleEstablishmentChange = (obj) => {
    this.setState({ establecimiento: obj });
  };

  handleInputTextChange = (evt) => {
    let inputID = evt.target.id,
      inputValue = evt.target.value.toUpperCase();

    // dependiendo del target id del evento cambiamos el estado de cantidad de texto o número
    if (inputID === "cantidad_texto") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputID);
      this.setState({ cantidad_texto: inputValue });
    }

    if (inputID === "cantidad_numero") {
      if (this.checkPositiveIntegers(inputValue)) {
        // limpamos errores si es que los hay
        this.cleanErrorsValidation(inputID);
        this.setState({ cantidad_numero: inputValue });
      }
    }

    if (inputID === "propietario_nombre") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputID);
      this.setState({ propietario_nombre: inputValue });
    }

    if (inputID === "propietario_direccion") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputID);
      this.setState({ propietario_direccion: inputValue });
    }

    if (inputID === "explotacion_pecuaria_razon") {
      this.setState({ explotacion_pecuaria_razon: inputValue });
    }

    if (inputID === "explotacion_pecuaria_direccion") {
      this.setState({ explotacion_pecuaria_direccion: inputValue });
    }

    if (inputID === "cantidad_tratar") {
      if (this.checkPositiveIntegers(inputValue)) {
        this.cleanErrorsValidation(inputID);
        this.setState({ cantidad_tratar: inputValue });
      }
    }

    if (inputID === "frecuencia") {
      if (this.checkPositiveIntegers(inputValue)) {
        this.cleanErrorsValidation(inputID);
        this.setState({ frecuencia: inputValue });
      }
    }

    if (inputID === "tratamiento") {
      if (this.checkPositiveIntegers(inputValue)) {
        this.cleanErrorsValidation(inputID);
        this.setState({ tratamiento: inputValue });
      }
    }
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let electronicPrescriptionData = { ...this.state };

    delete electronicPrescriptionData.cat_productos;
    delete electronicPrescriptionData.cat_presentacion_producto;
    delete electronicPrescriptionData.cat_producto_especie_dosis;
    delete electronicPrescriptionData.cat_medida_tiempo;
    delete electronicPrescriptionData.cat_establecimientos;
    delete electronicPrescriptionData.cat_producto_descarte;

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitForm(electronicPrescriptionData);
      }
    });
  };

  submitForm = (electronicPrescriptionData) => {
    Api.loading(true);
    Api.fetch(
      "app/storeElectronicPrescription",
      electronicPrescriptionData,
      "POST"
    ).then((data) => {
      if (data.errors) {
        this.handleValidations(data.errors);
        Api.loading(false);
        this.fireSwal(
          "¡Verifique que los datos esten correctamente completados!",
          "warning"
        );
        return false;
      } else {
        Api.loading(false);
        Swal.fire({
          icon: "success",
          title: "¡La receta ha sido generada exitosamente!",
          timer: 3000,
        }).then(() => {
          window.location.href = "/recetas-electronicas/expedidas";
        });
        this.resetStates();
      }
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors) => {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 3000,
    });
    return false;
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      producto: this.initialState.producto,
      presentacion: this.initialState.presentacion,
      establecimiento: this.initialState.establecimiento,
      fabricante: this.initialState.fabricante,
      cantidad_texto: this.initialState.cantidad_texto,
      cantidad_numero: this.initialState.cantidad_numero,
      paisOrigen: this.initialState.paisOrigen,
      propietario_nombre: this.initialState.propietario_nombre,
      propietario_direccion: this.initialState.propietario_direccion,
      explotacion_pecuaria_direccion:
        this.initialState.explotacion_pecuaria_direccion,
      explotacion_pecuaria_razon: this.initialState.explotacion_pecuaria_razon,
      cantidad_tratar: this.initialState.cantidad_tratar,
      producto_especie_dosis: this.initialState.producto_especie_dosis,
      frecuencia: this.initialState.frecuencia,
      tratamiento: this.initialState.tratamiento,
      producto_descarte: this.initialState.producto_descarte,
      medida_tiempo_frecuencia: this.initialState.medida_tiempo_frecuencia,
      medida_tiempo_tratamiento: this.initialState.medida_tiempo_tratamiento,
      cat_presentacion_producto: this.initialState.cat_presentacion_producto,
      cat_producto_especie_dosis: this.initialState.cat_producto_especie_dosis,
      cat_producto_descarte: this.initialState.cat_producto_descarte,
    });
  };

  /*********** Funciones ***********/

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegers = (str) => {
    let regex = /^[1-9]\d*$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <CreateForm
        state={this.state}
        handleProductChange={this.handleProductChange}
        handlePresentationChange={this.handlePresentationChange}
        handleInputTextChange={this.handleInputTextChange}
        handleDoseSpeciesChange={this.handleDoseSpeciesChange}
        handleTreatmentMeasureTimeChange={this.handleTreatmentMeasureTimeChange}
        handleFrecuencyMeasureTimeChange={this.handleFrecuencyMeasureTimeChange}
        handleSubmit={this.handleSubmit}
        handleEstablishmentChange={this.handleEstablishmentChange}
        handleWithdrawalPeriodChange={this.handleWithdrawalPeriodChange}
      />
    );
  }
}

export default ElectronicPrescription;
